import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Upload, Collapse } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import * as xlsx from 'xlsx';

import DescriptionTable from '../WikiDetail/WikiContent/WikiItemPerType/WikiItemDescription/DescriptionTable';

const { Panel } = Collapse;

interface WikiTableFormProps {
  formId: string;
  onChange: (id: any, data: any) => void;
}

const example = {
  type: 'table',
  data: {
    title: '스펙',
    columns: ['구분', 'LTE', '5G'],
    contents: [
      [
        '색상',
        '프리즘 화이트, 프리즘 블랙, 프리즘 그린',
        '크라운 실버, 마제스틱 블랙, 로얄 골드(256GB만 출시)',
      ],
      ['저장용량', '128GB, 512GB', '256GB, 512GB'],
      ['제품코드', 'SM-G973N', 'SM-G977N'],
      ['크기', '70.4 × 149.9 × 7.8mm', '77.1 × 162.6 × 7.94mm'],
      ['무게', '157g', '198g'],
      [
        '배터리',
        '3,400mAh(인터넷 사용 시간 최대 14시간)',
        '4,500mAh(인터넷 사용 시간 최대 17시간)',
      ],
      ['디스플레이', '6.1인치(15.49cm)', '6.7인치(17.01cm)'],
      ['운영체제', '안드로이드9(Pie)', '안드로이드9(Pie)'],
      [
        '카메라',
        '전면 1,000만 화소\n후면 1,600만 화소, 1,200만 화소 × 2',
        '전면 1,000만 화소\n후면 1,600만 화소, 1,200만 화소 × 2',
      ],
      [
        '구성품',
        '본품, 투명 케이스, USB 케이블, USB 충전 어댑터,\nUSB 커넥터(USB Type-C), 이어폰, 분리핀, 설명서',
        '본품, 투명 케이스, USB 케이블, USB 충전 어댑터,\nUSB 커넥터(USB Type-C), 이어폰, 분리핀, 설명서',
      ],
    ],
  },
};

const WikiTableForm: React.FC<WikiTableFormProps> = ({ formId, onChange }) => {
  const [tableTitle, setTableTitle] = useState('');
  const [tableData, setTableData] = useState<any>();

  useEffect(() => {
    const table = {
      type: 'table',
      data: {
        title: tableTitle, // stirng
        ...tableData, // columns, contents
      },
    };
    onChange(formId, table);
  }, [tableTitle, tableData]);

  const createWikiTableData = (array: any) => {
    let columns: any[] = [];
    const contents: any[] = [];
    array.forEach((item: any, index: any) => {
      if (item[0] === '표-컬럼' || item[0] === 'column') {
        item.shift();
        columns = item;
      } else if (item[0] === '표' || item[0] === 'row') {
        item.shift();
        contents.push(item);
      }
    });
    return { columns, contents };
  };

  const onload = (event: any) => {
    const file = event.target.result;
    const workBook = xlsx.read(file, { type: 'array', cellDates: true });
    // 1번 시트만 사용
    const sheetName = workBook.SheetNames[0];
    const sheet = workBook.Sheets[sheetName];
    // header : 1 옵션은 데이터를 2중 배열로 받겠다는 의미
    const data = xlsx.utils.sheet_to_json(sheet, { header: 1 });
    const table = createWikiTableData(data);
    setTableData(table);
    return table;
  };

  const dummyRequest = ({ file, onSuccess }: any) => {
    const reader = new FileReader();
    reader.onload = onload;
    reader.readAsArrayBuffer(file);
    setTimeout(() => {
      onSuccess('ok');
    }, 0);
  };

  return (
    <Form
      name="테이블"
      layout="vertical"
      labelCol={{ span: 8 }}
      wrapperCol={{ span: 16 }}
      autoComplete="off"
    >
      <Form.Item
        label="제목"
        name="title"
        rules={[{ required: true, message: '항목의 제목을 입력해주세요' }]}
      >
        <Input
          onChange={(event) => {
            setTableTitle(event.target.value);
          }}
        />
      </Form.Item>

      <Form.Item label="표 엑셀 파일" name="contents">
        <Upload customRequest={dummyRequest} maxCount={1}>
          <Button icon={<UploadOutlined />}>Upload</Button>
        </Upload>
        {tableData && (
          <Collapse>
            <Panel header="입력 데이터" key="1">
              <DescriptionTable
                data={{ title: tableTitle || '', ...tableData }}
              />
            </Panel>
          </Collapse>
        )}
      </Form.Item>
    </Form>
  );
};

export default WikiTableForm;
